import React, { useEffect, useRef, useState } from "react";
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON } from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import Modal from "../../components/common/Model";
import Inputwithlable from "../../components/common/inputwithlable";
import {
  addAdminSubDimension,
  deleteDimensionById,
  deleteSubDimensionById,
  getAdminSubDimensionBlock,
  getallAdminSubDimension,
  getAllDimensionByModelId,
  getAllModels,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { handleFormInput } from "../../../utills/formutilities";
import moment from "moment";
import SuccessModel from "../../components/common/SuccessModel";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import { API_RESPONSE } from "../../../utills/app-constant";
import DeleteModal from "../../components/common/DeleteModal";

const SubDimenstionManagement = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [disableDimension, setdisableDimension] = useState(true);
  const [totalElement, settotalElement] = useState();
  const [deleteSubDimensionId, setDeleteSubDimensionId] = useState(null);
  const [subdimensionPayload, setsubDimensionPayload] = useState({
    id: "",
    subDimensionName: "",
    sortName: "",
    subDimensionDescription: "",
    modelId: "",
    dimensionId: "",
  });

  const [isEditMode, setIsEditMode] = useState(false); // Track if in edit mode
  const [editModelId, setEditModelId] = useState(null); // Store model ID being edited
  const [modelList, setModelList] = useState([]);
  const [modelListActive, setModelListActive] = useState([]);
  const [modelId, setModelId] = useState("");
  const [dimensionId, setDimensionId] = useState("");
  const [modelId2, setModelId2] = useState(localStorage.getItem("sub-DimesionMenegmentModalId") || "");
  const [dimensionId2, setDimensionId2] = useState(localStorage.getItem("sub-DimesionMenegmentDimesionId") || "");
  const [dimensionList, setDimensionList] = useState([]);
  const [searchValue, setSearchValue] = useState(""); // Search state
  const [sortColumn, setSortColumn] = useState("id");
  const [isViewMode, setIsViewMode] = useState(false);
  const [viewModelId, setViewModelId] = useState(false)
  const [sortDirection, setSortDirection] = useState("desc");
  const [deleteSubDimensionName, setDeleteSubDimensionName] = useState();
  const addbuttonClick = useRef();
  const successModalRef = useRef();
  const { value } = useSelector((state) => state?.adminRole);
  const [permissionAccess, setPermissionAccess] = useState();
  let subDimesionModalId = localStorage.getItem("sub-DimesionMenegmentModalId");
  let subdimesiondimesionId = localStorage.getItem("sub-DimesionMenegmentDimesionId");
  const DeleteSubDiensionRef = useRef()


  useEffect(() => {
    const FlashAssessmentFilterData = value?.filter(
      (v) => v.moduleName === "Campaign Management"
    );
    setPermissionAccess(FlashAssessmentFilterData?.[0]);
  }, [value]);

  // Function to open modal for adding new model
  const addButtonClick = () => {
    setIsEditMode(false); // Reset to add mode
    setsubDimensionPayload({
      id: "",
      subDimensionName: "",
      sortName: "",
      subDimensionDescription: "",
      modelId: "",
      dimensionId: "",
    }); // Clear previous payload
    addbuttonClick.current.click();
  };

  // Function to open modal for editing a model
  const editButtonClick = (model) => {
    setDimensionList();
    getListOfDimension(model.modelResponse.id, model.dimensionResponse.enable);
    setIsEditMode(true); // Set to edit mode
    setsubDimensionPayload({
      id: model.id,
      subDimensionName: model.subDimensionName,
      sortName: model.sortName,
      subDimensionDescription: model.subDimensionDescription,
      modelId: model.modelResponse.id,
      dimensionId: model.dimensionResponse.id,
      enable: model.modelResponse.enable,
    });
    if (model.dimensionResponse.enable == false) {
      setdisableDimension(true);
    }
    setEditModelId(model.id);
    addbuttonClick.current.click();
  };

  const viewButtonClick = (model) => {
    setDimensionList();
    getListOfDimension(model.modelResponse.id, model.dimensionResponse.enable);
    setIsViewMode(true); // Set to edit mode
    setsubDimensionPayload({
      id: model.id,
      subDimensionName: model.subDimensionName,
      sortName: model.sortName,
      subDimensionDescription: model.subDimensionDescription,
      modelId: model.modelResponse.id,
      dimensionId: model.dimensionResponse.id,
      enable: model.modelResponse.enable,
    });
    if (model.dimensionResponse.enable == false) {
      setdisableDimension(true);
    }
    setViewModelId(model.id);
    addbuttonClick.current.click();
  };

  const getListOfSubDimension = async () => {
    try {
      setPending(true);
      const response = await getallAdminSubDimension(
        page,
        pageSize,
        searchValue,
        sortDirection,
        sortColumn, subDimesionModalId ? subDimesionModalId : modelId2, subdimesiondimesionId ? subdimesiondimesionId : dimensionId2
      );
      if (response?.data?.responseCode === 200) {
        setRowData(
          response?.data?.responseBody?.subDimensionResponsePayloadList
        );
        settotalElement(response?.data?.responseBody?.totalElement);
        setPending(false);
      } else {
        setPending(false);
        setRowData([]);
      }
    } catch (err) {
      setPending(false);
    }
  };

  const getListOfModel = async () => {
    try {
      const response = await getAllModels(0);
      if (response?.data?.responseCode === 404) {
        setModelList([]);
        setDimensionList([]);
      }
      else if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.modelName,
          Status: model.status,
        }));
        const modelOptionsActive = response?.data?.responseBody
          ?.filter((model) => model?.status === 1) // Only keep models with status === 1
          ?.map((model) => ({
            value: model.id,
            label: model.modelName,
            Status: model.status,
          }));
        setModelList(modelOptions);
        setModelListActive(modelOptionsActive)
      } else {
        setModelList([]);
        setDimensionList([]);
      }
    } catch (err) {
      // toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    getListOfModel();
  }, []);

  const getListOfDimension = async (id, enableStatus) => {
    let status = modelList?.filter(v => v?.value === id)

    try {
      const response = await getAllDimensionByModelId(id, status?.[0]?.Status);
      if (response?.data?.responseCode === 404) {
        setDimensionList([]);
      }
      else if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.dimensionName,
          Status: model.status,
        }));
        setDimensionList(modelOptions);
        if (enableStatus === false) {
          setdisableDimension(true);
        } else {
          setdisableDimension(false);
        }

      } else if (response?.data?.responseCode === 404) {
        setdisableDimension(false);
      }
      else {
        setDimensionList([]);  // Ensure that the dimension list is cleared properly if no valid response
      }
    } catch (err) {
      setDimensionList([]); // Clear the list if API fails
      console.error("Error fetching dimensions:", err);
    }
  };
  useEffect(() => {
    if (subDimesionModalId && modelList && modelList.length > 0) {
      getListOfDimension(subDimesionModalId);
    }
  }, [subDimesionModalId, modelList]);

  useEffect(() => {
    getListOfSubDimension();
  }, [page, pageSize, searchValue, sortColumn, sortDirection, modelId2, dimensionId2, subdimesiondimesionId, subDimesionModalId]);

  const handleChange = (event) => {
    setsubDimensionPayload(handleFormInput(event, subdimensionPayload));
  };

  const handleSelect = (event) => {
    if (event.target.value == "") {
      localStorage.removeItem("sub-DimesionMenegmentModalId");
      localStorage.removeItem("sub-DimesionMenegmentDimesionId");
      setModelId("")
      setDimensionId("")
      setModelId2("")
      setDimensionId2("")
      setDimensionList([])
    } else {
      if (event.target.name == "modelId2") {
        getListOfDimension(event.target.value);
        setModelId2(event.target.value)
        localStorage.setItem("sub-DimesionMenegmentModalId", event.target.value);
      }
      if (event.target.name == "dimensionId2") {
        setDimensionId2(event.target.value)
        localStorage.setItem("sub-DimesionMenegmentDimesionId", event.target.value);
      }
      if (event.target.name == "modelId") {
        getListOfDimension(event.target.value);
        setdisableDimension(true);
        setModelId(event.target.value)
      }
      if (event.target.name == "dimensionId") {
        setDimensionId(event.target.value)
      }
    }
    setsubDimensionPayload(handleFormInput(event, subdimensionPayload));
  };



  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    getListOfSubDimension();
  };

  function checkProperties(obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] !== "") return false;
    }
    return true;
  }

  const onAddOrEditModel = async () => {
    const isEmpty = checkProperties(subdimensionPayload);
    if (isEmpty) {
      return toastEmitter(
        "error",
        "Fields marked with an asterisk (*) are required!"
      );
    }
    if (
      subdimensionPayload.subDimensionName === null ||
      subdimensionPayload.subDimensionName?.trim() === ""
    ) {
      return toastEmitter("error", "Sub Dimension Name Is Required!");
    }
    if (
      subdimensionPayload.sortName === null ||
      subdimensionPayload.sortName?.trim() === ""
    ) {
      return toastEmitter("error", "Sub Dimension Sort Name Is Required!");
    }
    if (
      subdimensionPayload.modelId === null ||
      subdimensionPayload.modelId === ""
    ) {
      return toastEmitter("error", "Model Is Required!");
    }
    if (
      subdimensionPayload.dimensionId === null ||
      subdimensionPayload.dimensionId === ""
    ) {
      return toastEmitter("error", "Dimension Is Required!");
    }
    if (
      subdimensionPayload.subDimensionDescription === null ||
      subdimensionPayload.subDimensionDescription?.trim() === ""
    ) {
      return toastEmitter("error", "Sub Dimension Description Is Required!");
    }

    try {
      let response = await addAdminSubDimension(subdimensionPayload); // Update model
      if (response?.data?.responseCode === 200) {
        successModalRef.current.click();
        getListOfSubDimension();
        addbuttonClick.current.click();
        successModalRef.current.click();
      } else if (response?.data?.responseCode === 400) {
        toastEmitter("error", response?.data?.message);
      } else {
        console.error("Failed to add or edit dimension");
      }
    } catch (error) {
      console.error("Error during add/edit dimension:", error);
    }
  };

  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1;
    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update the row data state locally
    try {
      let response = await getAdminSubDimensionBlock(row.id, newStatus);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else if (response?.data?.responseCode === 400) {
        toastEmitter("danger", response?.data?.message);
        // Revert the status change if the API returns an error
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
      } else {
        console.error("Failed to change model status");
        // Revert the status change if an unexpected response is received
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
      }
    } catch (error) {
      console.error("Error during status change:", error);
      // Revert the status change in case of an error
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
    }
  };

  const deleteButtonClick = (id, name) => {
    setDeleteSubDimensionId(id)
    setDeleteSubDimensionName(name)
    DeleteSubDiensionRef.current.click();
  }

  const handleSubDimensionDelete = async () => {
    try {
      const response = await deleteSubDimensionById(deleteSubDimensionId);
      if (response?.data?.responseCode === 200) {
        toastEmitter('success', response.data.message)
        getListOfSubDimension();
      } else {
        toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
      }
    } catch (err) {
      // toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
    }
  }


  const handleClearAll = () => {
    localStorage.removeItem("sub-DimesionMenegmentModalId");
    localStorage.removeItem("sub-DimesionMenegmentDimesionId");
    setModelId2("")
    setDimensionId2("")
  }

  const tblColumns = [
    ...(permissionAccess?.updateAction === 1
      ? [
        {
          code: "Action",
          name: "Action",
          width: "130px",
          sortable: false,
          cell: (row) => (
            <div>
              <button
                className="border-0 bg-white"
                onClick={() => editButtonClick(row)}
              >
                <img src={EDIT_ICON} alt="Edit" className="editicon" />
              </button>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => viewButtonClick(row)}
                >  <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => deleteButtonClick(row?.id, row?.subDimensionName)}
                >  <img src={DELETE_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
            </div>
          ),
        },
      ]
      : []),
    {
      code: "subDimensionId",
      name: "Sub-Dimension Id",
      width: "150px",
      sortable: true,
      selector: (row) => `${row?.subDimensionId}`,
    },
    {
      code: "subDimensionName",
      name: "Sub-Dimension",
      width: "250px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.subDimensionName}</div>
      ),
    },
    {
      code: "dimensionName",
      name: "Dimension Name",
      width: "170px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.dimensionResponse?.dimensionName}</div>
      ),
    },
    {
      code: "modelName",
      name: "Model Name",
      width: "200px",
      sortable: true,

      selector: (row) => (
        <div className="table-cell-content">{row?.modelResponse?.modelName}</div>
      ),
    },
    {
      code: "sortName",
      name: "Short Name",
      width: "200px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.sortName}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      width: "160px",
      sortable: true,
      cell: (row) => (
        <div class="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },
    {
      code: "updatedDate",
      name: "Last Update",
      sortable: true,
      width: "160px",

      selector: (row) => moment(row?.updatedDate).format("MM/DD/YYYY"), // Adjust format as needed
    },

  ];


  return (
    <>
      {permissionAccess?.addAction == 0 &&
        permissionAccess?.updateAction == 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading
              firstData="Assessment Modeling"
              icon={RIGHTARROW_ICON}
              secondData="Sub-Dimension Management"

            />
            <div className="container-fluid ">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  searchValue={searchValue}
                  onSearchChange={handleSearchChange}
                  data="Sub-Dimension"
                  addButtonClick={addButtonClick}
                  addbuttonClick={addbuttonClick}
                  permissionAccessbtn={permissionAccess?.addAction}
                />
                <div className="row m-0 mb-4">
                  <div className="col-12 col-md-6 col-lg-5">
                    <DropDownWithLabel
                      name="modelId2"
                      labelName="Select Maturity Model"
                      className="addInputText-lable"
                      lableclassName="addInput-label"
                      options={modelList}
                      value={subDimesionModalId ? subDimesionModalId : modelId2}
                      handleSelect={handleSelect}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-5">
                    <DropDownWithLabel
                      labelName="Select Dimension"
                      name="dimensionId2"
                      options={dimensionList}
                      lableclassName="addInput-label"
                      value={subdimesiondimesionId ? subdimesiondimesionId : dimensionId2}
                      handleSelect={handleSelect}
                      className="addInputText-lable"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-2  d-flex justify-content-lg-end  d-flex justify-content-start">
                    <button className="border-0 bg-primary text-white rounded-2 p-1 clearall-btn w-75 mt-3 textfont12" onClick={handleClearAll}>Clear All</button>
                  </div>
                </div>

                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={{}}
                  _totalRows={totalElement}
                  pending={pending}
                  setPending={setPending}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
              </div>
            </div>
          </div>

          <Modal
            heading="Sub-Dimension Management"
            modalClick={addbuttonClick}
            title={isViewMode ? "View Sub-Dimension" : isEditMode ? "Update Sub Dimension" : "Add Sub-Dimension"}
            onAddItem={onAddOrEditModel}
            buttonLable={isViewMode ? "" : isEditMode ? "Update" : "Add"}
            className="modal-lg"
          >
            <div className="row">
              <div className="col-md-6">
                <Inputwithlable
                  placeHolder="Enter Sub-Dimension Name"
                  name="subDimensionName"
                  type="text"
                  showastrict={true}
                  labelName="Enter Sub-Dimension Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={subdimensionPayload.subDimensionName} // Bind selected value
                  handleChange={handleChange} // Unified onChange handler
                  maxlng={64}
                  disable={isViewMode}
                />
              </div>

              <div className="col-md-6">
                <Inputwithlable
                  placeHolder="Enter Sub-Dimension Short Name"
                  name="sortName"
                  type="text"
                  showastrict={true}
                  labelName="Enter Sub-Dimension Short Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={subdimensionPayload.sortName} // Bind selected value
                  handleChange={handleChange} // Unified onChange handler
                  maxlng={64}
                  disable={isViewMode}
                />
              </div>

              <div className="col-md-6">
                <DropDownWithLabel
                  labelName="Select Maturity Model"
                  lableclassName="input-label"
                  name="modelId"
                  options={modelListActive}
                  showastrict={true}
                  className="form-control inputText-lable"
                  value={subdimensionPayload.modelId} // Bind selected value
                  handleSelect={handleSelect} // Unified onChange handler for dropdown
                  disabled={isViewMode || subdimensionPayload?.enable === false}
                  message={subdimensionPayload?.enable === false ? "This subdimension already exists ,and the model cannot be modified" : ""}

                />
              </div>

              <div className="col-md-6">
                <DropDownWithLabel
                  labelName="Select Dimension"
                  lableclassName="input-label"
                  name="dimensionId"
                  options={dimensionList}
                  showastrict={true}
                  className="form-control inputText-lable"
                  value={subdimensionPayload.dimensionId} // Bind selected value
                  handleSelect={handleSelect} // Unified onChange handler for dropdown
                  // disabled={subdimensionPayload?.enable === false } 
                  disabled={isViewMode || disableDimension}
                  message={subdimensionPayload?.enable === false ? "This subdimension already exists ,and the dimension cannot be modified" : ""}
                />
              </div>

              <div className="col-md-12">
                <Inputwithlable
                  placeHolder="Enter Description"
                  name="subDimensionDescription"
                  type="text"
                  showastrict={true}
                  labelName="Enter Sub-Dimension Description"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={subdimensionPayload.subDimensionDescription} // Bind selected value
                  handleChange={handleChange} // Unified onChange handler
                  disable={isViewMode}
                />
              </div>
            </div>
          </Modal>
          <SuccessModel
            title={isEditMode ? "Sub Dimension Updated" : "Sub Dimension Added"}
            SuccessModel={successModalRef}
          />
          <DeleteModal
            DeleteModalRef={DeleteSubDiensionRef}
            title="Sub-Dimension"
            name={deleteSubDimensionName}
            warningMsg="⚠️If you delete this Sub-dimensions. All the criteria associated with it will automatically deleted."
            handleDelete={handleSubDimensionDelete}
          />
        </>
      )}
    </>
  );
};

export default SubDimenstionManagement;
